<mat-toolbar style="background-color: var(--baseprimarycolor);color: white;">
    <h3> {{student.person.lastName}}, {{student.person.firstName}}
        {{student.person.middleName}} </h3>
</mat-toolbar>
<mat-divider></mat-divider>
<table class="details-list container-fluid">
    <tbody>
        <tr class="detail">
            <td class="label">Institution ID</td>
            <td class="value">{{student.institutionId | mask: '00-000-0000'}}</td>
        </tr>
        <tr class="detail">
            <td class="label">Workday ID</td>
            <td class="value">{{student.workdayId}}</td>
        </tr> 
        <tr class="detail">
            <td class="label">Name</td>
            <td class="value">{{student.person.lastName}}, {{student.person.firstName}}
                {{student.person.middleName}}</td>
        </tr>
        <tr class="detail">
            <td class="label">Primary Sport</td>
            <td class="value">{{student.primarySport}}</td>
        </tr>
        <tr class="detail">
            <td class="label">Last Season</td>
            <td class="value">{{student.lastSeason}}</td>
        </tr>
    </tbody>
</table>
<mat-divider>
</mat-divider>
<div class="action-button-group flex details-actions-bottom ">
    <div class="action-button flex  outer" *ngIf="ReadCompliance">
        <span><button (click)="editStudent(student)" class="action-icon  outer">
                <div class="inner-wrapper">
                    <mat-icon style="color: white;">edit</mat-icon>
                </div>
            </button><span class="label">Compliance</span></span>
    </div>   
    <div class="action-button flex  outer"  *ngIf="ReadFinancialAid">
        <span><button (click)="financialAid(student)" class="action-icon  outer">
                <div class="inner-wrapper">
                    <mat-icon style="color: white;">request_quote</mat-icon>
                </div>
            </button><span class="label"> Financial Aid</span></span>
    </div>
    <div class="action-button flex  outer" *ngIf="ReadCertification">
        <span><button (click)="certification(student)" class="action-icon  outer">
                <div class="inner-wrapper">
                    <mat-icon style="color: white;">model_training</mat-icon>
                </div>
            </button><span class="label"> Academics</span></span>
    </div>
    <div class="action-button flex  outer" *ngIf="ReadProspective">
        <span>
            <button (click)="prospectiveStudent(student)" class="action-icon  outer">
                <div class="inner-wrapper">
                    <mat-icon style="color: white;">person</mat-icon>
                </div>
            </button>
            <span class="label">Prospective</span>
        </span>
    </div>
</div>
<div class="action-button-group flex details-actions-bottom ">
    <div class="action-button flex  outer" *ngIf="ReadCompliance">
        <span>
            <button (click)="admissionStatusReport(student)" class="action-icon  outer">
                <div class="inner-wrapper">
                    <mat-icon style="color: white;">description</mat-icon>
                </div>
            </button>
            <span class="label">Admission Status Report</span>
        </span>
    </div>      
</div>
